// @flow
export { default } from './CartTemplate';



// WEBPACK FOOTER //
// ./src/components/cart/CartTemplate/index.js